/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiClassificationFromJSON, ApiClassificationToJSON, } from './ApiClassification';
import { ApiClassificationItemFromJSON, ApiClassificationItemToJSON, } from './ApiClassificationItem';
import { ApiClassificationRuleFromJSON, ApiClassificationRuleToJSON, } from './ApiClassificationRule';
import { ApiConditionCustomFromJSON, ApiConditionCustomToJSON, } from './ApiConditionCustom';
import { ApiConditionGroupFromJSON, ApiConditionGroupToJSON, } from './ApiConditionGroup';
import { ApiConditionValueTypeFromJSON, ApiConditionValueTypeToJSON, } from './ApiConditionValueType';
import { ApiConversionFromJSON, ApiConversionToJSON, } from './ApiConversion';
import { ApiOperatorFromJSON, ApiOperatorToJSON, } from './ApiOperator';
export function ApiConditionFromJSON(json) {
    return ApiConditionFromJSONTyped(json, false);
}
export function ApiConditionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'classification': !exists(json, 'classification') ? undefined : ApiClassificationFromJSON(json['classification']),
        'classificationId': !exists(json, 'classificationId') ? undefined : json['classificationId'],
        'classificationItemId': !exists(json, 'classificationItemId') ? undefined : json['classificationItemId'],
        'classificationRule': !exists(json, 'classificationRule') ? undefined : ApiClassificationRuleFromJSON(json['classificationRule']),
        'classificationValue': !exists(json, 'classificationValue') ? undefined : ApiClassificationItemFromJSON(json['classificationValue']),
        'conditionGroup': !exists(json, 'conditionGroup') ? undefined : ApiConditionGroupFromJSON(json['conditionGroup']),
        'conversion': !exists(json, 'conversion') ? undefined : ApiConversionFromJSON(json['conversion']),
        'conversionId': !exists(json, 'conversionId') ? undefined : json['conversionId'],
        'custom': !exists(json, 'custom') ? undefined : ApiConditionCustomFromJSON(json['custom']),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'operator': !exists(json, 'operator') ? undefined : ApiOperatorFromJSON(json['operator']),
        'value': !exists(json, 'value') ? undefined : json['value'],
        'valueType': !exists(json, 'valueType') ? undefined : ApiConditionValueTypeFromJSON(json['valueType']),
    };
}
export function ApiConditionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'classification': ApiClassificationToJSON(value.classification),
        'classificationId': value.classificationId,
        'classificationItemId': value.classificationItemId,
        'classificationRule': ApiClassificationRuleToJSON(value.classificationRule),
        'classificationValue': ApiClassificationItemToJSON(value.classificationValue),
        'conditionGroup': ApiConditionGroupToJSON(value.conditionGroup),
        'conversion': ApiConversionToJSON(value.conversion),
        'conversionId': value.conversionId,
        'custom': ApiConditionCustomToJSON(value.custom),
        'id': value.id,
        'operator': ApiOperatorToJSON(value.operator),
        'value': value.value,
        'valueType': ApiConditionValueTypeToJSON(value.valueType),
    };
}
